import { render, staticRenderFns } from "./datasubject-datasubject-right-form.vue?vue&type=template&id=2d44dd4b"
import script from "./datasubject-datasubject-right-form.vue?vue&type=script&lang=js"
export * from "./datasubject-datasubject-right-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports